<template>
  <v-container>
    <reactive-base
      app="elements"
      :url="apiUri"
      :headers="{authorization: `Bearer ${this.$keycloak.token}`}"
    >
      <v-row justify="center">
        <v-col cols="12" sm="8">
          <data-search
            componentId="search"
            placeholder="Rechercher un groupe"
            :data-field="['name', 'brand', 'type', 'inventoryNumber']"
            :field-weight="[3,1,2]"
            :fuzziness="0"
            :size="10"
            :debounce="100"
            :URLParams="true"
            :autosuggest="false"
            queryFormat="and"
          />
        </v-col>
        <v-col cols="12" sm="8" xl="10">
          <reactive-list
            componentId="ReactiveList"
            :react="{ and: ['search']}"
            data-field="name"
            sortBy="asc"
          >
            <div slot="renderItem" slot-scope="{ item }">
              <v-card class="my-5" @click="$router.push(`/groups/${item.group._id}`)" :ripple="false" v-if="item.group">
                <v-card-title>
                  {{item.group.name}}
                </v-card-title>
                <v-card-subtitle>Cliquez pour les détails</v-card-subtitle>
              </v-card>
            </div>
          </reactive-list>
        </v-col>
      </v-row>
    </reactive-base>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    apiUri: process.env.VUE_APP_API_URI
  })
};
</script>